// src/components/GlobalLoader.tsx
import React, { useEffect, useState } from "react";
import LoaderService from "../services/LoaderService";

const GlobalLoader = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const unsubscribe = LoaderService.subscribe(setVisible);
    return unsubscribe;
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[51] bg-black bg-opacity-50 flex items-center justify-center">
      <div className="w-12 h-12 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin" />
    </div>
  );
};

export default GlobalLoader;
